import { Avatar, Flex, Menu, Text } from "@mantine/core";
import React, { memo, useCallback } from "react";
import Cookies from "js-cookie";
import {
  IconLogout,
  IconVideo,
  IconUser,
  IconUsers,
  IconSwitchHorizontal,
  IconShieldCheck,
} from "@tabler/icons-react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { accountLinks, otherRoles, switchRole, ROLE_NAME } from "../../lib/accountMenu";
import styles from "./styles.module.scss";

const ICONS = { user: IconUser, video: IconVideo, users: IconUsers, shield: IconShieldCheck };

const AppActionsMenu = memo(({ currentUser, setCurrentUser, randomAvatar }) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { push } = useHistory();


  const onLogout = useCallback(() => {
    Cookies.remove("vb-access-token");
    Cookies.remove("vb-refresh-token");
    setCurrentUser(null);
  }, [setCurrentUser]);


  const darkMenuStyles = {
    dropdown: {
      background: "rgba(13, 13, 20, 0.95)",
      backdropFilter: "blur(18px)",
      WebkitBackdropFilter: "blur(18px)",
      border: "1px solid rgba(255,255,255,0.1)",
      borderRadius: "12px",
      padding: "6px",
    },
    label: {
      color: "rgba(255,255,255,0.4)",
      fontSize: "11px",
      letterSpacing: "0.8px",
      textTransform: "uppercase",
    },
    divider: { borderColor: "rgba(255,255,255,0.1)" },
    item: {
      color: "rgba(255,255,255,0.85)",
      borderRadius: "8px",
      fontSize: "13px",
      fontWeight: 500,
      "&:hover": {
        background: "rgba(93,236,255,0.1)",
        color: "#fff",
      },
    },
  };

  return (
    <Flex align="center">
      <Menu shadow="md" width={210} className={styles.menu} styles={darkMenuStyles}>
        <Menu.Target>
          <Flex align="center" gap="md">
            <Text fz={12} fw={500} className={styles.userName}>
              {currentUser?.name?.split(' ')[0]}
            </Text>
            <Avatar
              src={
                !!currentUser?.avatarUrl ? currentUser.avatarUrl : randomAvatar
              }
            />
          </Flex>
        </Menu.Target>
        
      <Menu.Dropdown>
        {accountLinks(currentUser, pathname).map((x) => {
          const Icon = ICONS[x.icon] || IconVideo;
          return (
            <Menu.Item key={x.key} onClick={() => push(x.path)} icon={<Icon color="#5decff" size={15} />}>
              {x.label}
            </Menu.Item>
          );
        })}

        {otherRoles(currentUser).map((role) => (
          <Menu.Item key={role} onClick={() => switchRole(role)} icon={<IconSwitchHorizontal color="#5decff" size={15} />}>
            Switch to {ROLE_NAME[role] || role} role
          </Menu.Item>
        ))}

        <Menu.Item
          onClick={onLogout}
          icon={<IconLogout color="#5decff" size={15} />}
        >
          {t("logout")}
        </Menu.Item>
      </Menu.Dropdown>
      </Menu>
      

    </Flex>
  );
});

export default AppActionsMenu;
